var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.acesso.instituicao ? _c("AlertSystemBar") : _vm._e(),
      _c("SysCoreNavigationBar"),
      _c(
        "v-main",
        [
          _c("GovernanceWarningBanner"),
          _c("v-container", { attrs: { fluid: "" } }, [_c("router-view")], 1),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "v-bottom-sheet",
            {
              attrs: { "hide-overlay": "", inset: "" },
              model: {
                value: _vm.sheet,
                callback: function ($$v) {
                  _vm.sheet = $$v
                },
                expression: "sheet",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { tile: "" } },
                [
                  _c("v-progress-linear", {
                    staticClass: "my-0",
                    attrs: { value: 0, height: "5", color: "red" },
                  }),
                  _vm.hasErrors
                    ? _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c(
                            "v-card-title",
                            [
                              _c("v-spacer"),
                              _vm.acesso.instituicao &&
                              _vm.acesso.instituicao.educational_group_id != 16
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        color: "info",
                                        outlined: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showOpenTicket = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(" Abrir um chamado "),
                                      _c("v-icon", { attrs: { right: "" } }, [
                                        _vm._v("mdi-text-box-plus"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    text: "",
                                    outlined: "",
                                    color: "red",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.sheet = !_vm.sheet
                                    },
                                  },
                                },
                                [
                                  _vm._v(" Fechar mensagem "),
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "red", right: "" } },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "py-3" },
                    _vm._l(_vm.errorsHttp, function (item, i) {
                      return _c(
                        "v-alert",
                        {
                          key: i,
                          staticClass: "red--text",
                          attrs: { dense: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "prepend",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass:
                                          "red--text text--lighten-1",
                                      },
                                      [_vm._v("mdi-alert-circle")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          item.status == 500
                            ? _c("div", { staticClass: "text-center" }, [
                                _c(
                                  "p",
                                  { staticClass: "text-h5 mt-2 red--text" },
                                  [_vm._v("Ocorreu um erro inesperado!")]
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "v-row",
                            {
                              staticClass: "ml-2",
                              attrs: { align: "center", "no-gutters": "" },
                            },
                            [
                              _c("v-col", { staticClass: "grow" }, [
                                _vm.hasErrors
                                  ? _c("p", { staticClass: "ma-0" }, [
                                      _c("strong", [_vm._v("Erro:")]),
                                      _vm._v(" " + _vm._s(item.status)),
                                    ])
                                  : _vm._e(),
                                _vm.hasErrors
                                  ? _c("p", { staticClass: "ma-0" }, [
                                      _c("strong", [_vm._v("Requisição:")]),
                                      _vm._v(" " + _vm._s(item.url)),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ma-0 red--text text--lighten-2",
                                  },
                                  [
                                    _c("strong", [_vm._v("Mensagem:")]),
                                    _vm._v(" " + _vm._s(item.message)),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("OpenTicket", {
        attrs: { show: _vm.showOpenTicket },
        on: { "update:show": (value) => (_vm.showOpenTicket = value) },
      }),
      _vm.user.is_internal ||
      ([2171, 1251, 1928, 336, 337, 335, 853].includes(_vm.user.id) &&
        _vm.isAnima())
        ? _c("ChatBot")
        : _vm._e(),
      _c("OccupancyBlockOverlay"),
      _c("MenuAccessBlockWatcher"),
      _c("SessionChangedWatcher"),
      _c("sys-term-profile-blocking-modal", {
        attrs: {
          show: _vm.showProfileBlockingModal,
          teacherId: _vm.teacherId,
          token: _vm.token,
          "initial-terms": _vm.pendingBlockingTerms,
        },
        on: {
          "update:show": function ($event) {
            _vm.showProfileBlockingModal = $event
          },
          unblocked: _vm.onProfileUnblocked,
        },
      }),
      _c("SysCoreFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }